import { GltfService } from '@partful/features/instructions/cad/api/gltfService';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Object3D } from 'three';

export interface UseModelProps {
  account: string;
  product: string;
}

export const useModel = (props: UseModelProps) => {
  const gltf = useMemo(() => new GltfService(), []);

  const [model, setModel] = useState<Object3D>();
  const [error, setError] = useState<string>();
  const [fetching, setFetching] = useState(false);

  const fetch = useCallback(
    async ({ account, product }: UseModelProps, active = true) => {
      try {
        if (active) setFetching(true);
        const { scene } = await gltf.get(account, product);
        if (active) setModel(scene);
      } catch (reason) {
        if (!active) return;
        if (reason instanceof Error) {
          setError(reason.message);
        } else {
          setError('An unknown error occurred');
        }
      } finally {
        if (active) setFetching(false);
      }
    },
    [gltf]
  );

  useEffect(() => {
    let active = true;
    fetch({ account: props.account, product: props.product }, active);
    return () => {
      active = false;
    };
  }, [fetch, props.account, props.product]);

  return [{ data: model, fetching, error }, fetch] as const;
};
